import { IUserInChatListSchema } from '../types/userData';
import { getChatUserByRole } from './getChatUserByRole';

/**
 * Возвращает собеседника в элементе списка чатов: для инициатора чата — оппонента,
 * а если его нет — компаньона, для остальных участников — инициатора.
 */
export function getChatListItemCompanion(
  chatUsers: IUserInChatListSchema[],
  userId: number,
): IUserInChatListSchema | undefined {
  const opponent = getChatUserByRole(chatUsers, 'opponent');
  const initiator = getChatUserByRole(chatUsers, 'initiator');
  const companion = getChatUserByRole(chatUsers, 'companion');

  if (initiator?.userId === userId) {
    return opponent || companion;
  }

  return initiator;
}
